import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CalendlyFab from '../components/CalendlyFab';
import KlassiBrand from '../components/KlassiBrand';

const Home = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3 text-light">Welcome to the <KlassiBrand /> Brand</h1>
          <p className="lead text-warning fw-bold">Where klassi things happen...</p>
        </div>

        <Row className="g-4 mb-5 justify-content-center">
          {/*<Col xs={12} md={6} lg={3} className="text-center">*/}
          {/*  <Link to="/about" className="text-decoration-none">*/}
          {/*    <div className="p-3">*/}
          {/*      <img*/}
          {/*        src="/logo.png"*/}
          {/*        alt="About Us"*/}
          {/*        className="img-fluid rounded"*/}
          {/*        style={{*/}
          {/*          cursor: 'pointer',*/}
          {/*          width: '150px',*/}
          {/*          height: '150px',*/}
          {/*          objectFit: 'cover',*/}
          {/*          border: '3px solid #FFD700',*/}
          {/*          borderRadius: '15px'*/}
          {/*        }}*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*    <h3 className="mt-3 text-light fw-bold">About Us</h3>*/}
          {/*    <p className="text-light-50">*/}
          {/*      Learn about our mission, values, and the team behind Klassi.*/}
          {/*      Discover how we're transforming businesses through innovation.*/}
          {/*    </p>*/}
          {/*  </Link>*/}
          {/*</Col>*/}
          <Col xs={12} md={6} lg={3} className="text-center">
            <Link to="/klassitech" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/logo.png" 
                  alt="KlassiTech"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">KlassiTech</h3>
              <p className="text-light-50">
                We deliver cutting-edge technology solutions tailored to your business — from intelligent automation and AI integration to scalable, future-ready software systems — empowering you to streamline operations, enhance decision-making, and drive innovation across every level of your organization in today’s fast-paced digital landscape.
              </p>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={3} className="text-center">
            <Link to="https://ktestGenie.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
              <div className="p-3">
                <img
                  src="/logo.png"
                  alt="TestGenie"
                  className="img-fluid rounded"
                  style={{
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">TestGenie</h3>
              <p className="text-light-50">
              Test Genie automatically extracts business requirements from BRDs, user stories, Confluence exports, or Jira tickets and generates clear acceptance criteria, and creates high-quality test cases and Gherkin scenarios ready for your QA workflow. Upload once, generate Gherkin, refine in seconds—then push straight to Zephyr Scale or keep them in your repo.
              </p>
            </Link>
          </Col>
          {/* <Col xs={12} md={6} lg={3} className="text-center">
            <Link to="/klassicare" className="text-decoration-none">
              <div className="p-3">
                <img
                  src="/logo.png"
                  alt="KlassiCare"
                  className="img-fluid rounded"
                  style={{
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">KlassiCare</h3>
              <p className="text-light-50">
                Our mission is to provide families with one of our carefully selected nannies—professionals who support, care for, and educate your children—through a meticulous recruitment process designed to ensure a harmonious match where every piece fits perfectly, guided by your specific requirements and our unwavering commitment to excellence, resulting in exceptional childcare services tailored to your needs and delivered with a personal touch.
              </p>
            </Link>
          </Col> */}
        </Row>


        {/*<h1 className="text-center display-4 fw-bold mb-5 text-light">About Us</h1>*/}
        <p className="lead text-warning text-center fw-bold"><KlassiBrand/> - A Vision Beyond Boundaries</p>
        <p className="text-primary mb-4">
          <p>
            At Klassi, we believe in the power of innovation to transform lives, industries, and the future. What began as a bold idea to bridge technology and purpose has evolved into a dynamic ecosystem of ventures—each designed to address real-world challenges with creativity, intelligence, and heart.</p>
          <p>
            We are more than a brand. We are a movement driven by a shared mission: to build meaningful solutions that empower people and businesses to thrive in a rapidly changing world.
          </p>
        </p>
        <Row className="g-4">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light fw-bold mb-4">Our Ecosystem</h2>
              <p className="text-primary mb-4">
                Klassi is home to a growing family of specialized ventures, each with a distinct focus but united by a common vision of excellence and impact:
                <p></p>
                <ul>
                  <li><strong>KlassiTech:</strong>
                    As the technology powerhouse of the Klassi brand, KlassiTech delivers innovative, high-performance software solutions designed to accelerate digital transformation and fuel sustainable business growth. We harness the latest technologies to help organizations evolve, adapt, and lead in a digital-first world.
                  </li>

                  {/*<li><strong>KlassiCare:</strong>*/}
                  {/*  Dedicated to nurturing the next generation, KlassiCare provides innovative, accessible childcare solutions that support the well-being, development, and happiness of every child. We are committed to creating safe, enriching environments where children can grow, learn, and thrive—while giving families the confidence and support they need every step of the way.*/}
                  {/*</li>*/}

                  {/*<li><strong>KlassiFashion:</strong>*/}
                  {/*    Where style meets sustainability. KlassiFashion redefines modern fashion with a focus on ethical design, inclusivity, and self-expression.*/}
                  {/*</li>*/}

                  <li><strong>More to Come...</strong>
                      We are continuously exploring new frontiers—from education and finance to lifestyle and beyond. Wherever there’s a need for smart, human-centered innovation, Klassi will be there.
                  </li>
                </ul>
              </p>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light fw-bold mb-4">Our Philosophy</h2>
              <p className="text-primary mb-4">
                <p>
                  At the heart of Klassi is a belief in <strong>purpose-driven innovation</strong>. We don’t just build products—we create
                  experiences that inspire, empower, and endure. Every Klassi venture is guided by our core values: integrity, creativity,
                  excellence, and a relentless commitment to making a difference.
                </p>
              </p>
              <h2 className="text-light fw-bold mb-4">The Future is <KlassiBrand /></h2>
              <p className="text-primary mb-4">
                <p>
                  As we grow, so does our ambition. We are building a future where technology, care, fashion, and more coexist in harmony—each enhancing the other to create a better world for all.</p>
                <p>
                  Join us on this journey. Be part of something bigger. Be part of Klassi.
                </p>
              </p>
            </div>
          </Col>
        </Row>

        <CalendlyFab />
      </Container>
    </div>
  );
};

export default Home; 